// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"41db341c","293":"1012f984","360":"741d5dab","453":"99e2b55a","908":"aa560a21"}[chunkId] + ".chunk.js";
};